import { TripMessageState } from '@marageti/z4-sdk/lib/travel';
import React from 'react';

const NotificationDot = () => (
  <span
    style={{
      height: '8px',
      width: '8px',
      backgroundColor: '#0089FC',
      borderRadius: '50%',
      display: 'inline-block',
      verticalAlign: 'middle',
    }}
  />
);

const MinimalChatIndicator = ({
  userId,
  tripMessageState,
}: {
  userId: string,
  tripMessageState: TripMessageState,
}) => {
  const assignedToMessageState = tripMessageState.find((m) => m.personId !== '' && m.personId === userId);
  const hasNewMessage = assignedToMessageState?.hasNew || false;
  return hasNewMessage ? <NotificationDot /> : null;
};

export default MinimalChatIndicator;
